import { capitalizeFirstLetter } from "../utils/utils";

export class TradeMeasure {
  constructor(enactingCountry, tradeDirection, typeOfMeasure, affectedProducts, affectedHSCodes, measure, affectedPartners, statusOfMeasure, internalLink, startDate, endDate, effectOnTrade) {
    this.enactingCountry = enactingCountry || "";
    this.tradeDirection = tradeDirection || "";
    this.typeOfMeasure = typeOfMeasure || "";
    this.affectedProducts = affectedProducts || "";
    this.affectedHSCodes = affectedHSCodes || "";
    this.measure = measure || "";
    this.affectedPartners = affectedPartners || "";
    this.statusOfMeasure = statusOfMeasure || "";
    this.internalLink = internalLink || "";
    this.startDate = startDate || "";
    this.endDate = endDate || "";
    this.effectOnTrade = effectOnTrade || "";
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new TradeMeasure(input.EnactingCountry, input.TradeDirection, input.TypeOfMeasure, input.AffectedProducts, input.AffectedHSCodes, input.Measure, input.AffectedPartners, input.StatusOfMeasure, input.InternalLink, input.StartDate, input.EndDate, input.EffectOnTrade)
    }
    return new TradeMeasure();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => TradeMeasure.fromApiObject(item));
    }
    if (typeof (input) === "object") {
      return [TradeMeasure.fromApiObject(input)];
    }
    return [];
  }

  search(keyword = "") {
    let string = keyword.toLowerCase();
    return this.enactingCountry.toLowerCase().indexOf(string) !== -1 || this.tradeDirection.toLowerCase().indexOf(string) !== -1 || this.typeOfMeasure.toLowerCase().indexOf(string) !== -1 || this.affectedProducts.toLowerCase().indexOf(string) !== -1 || this.affectedHSCodes.toLowerCase().indexOf(string) !== -1 || this.measure.toLowerCase().indexOf(string) !== -1 || this.statusOfMeasure.toLowerCase().indexOf(string) !== -1 || this.affectedHSCodes.toLowerCase().indexOf(string) !== -1 || this.internalLink.toLowerCase().indexOf(string) !== -1 || this.startDate.toLowerCase().indexOf(string) !== -1 || this.endDate.toLowerCase().indexOf(string) !== -1 || this.effectOnTrade.toLowerCase().indexOf(string) !== -1 || this.affectedPartners.toLowerCase().indexOf(string) !== -1
  }

  genHtml() {
    let affectedHSCodes = "";
    if (this.affectedHSCodes) {
      affectedHSCodes = `
      <div class="instruction">
        <div class="dropdown">
          <div class="content">
            <b>Official HS codes affected</b><div>${this.affectedHSCodes}</div>
          </div>
        </div>
      </div>
      `;
    }
    return `
    <tr>
      <td>
        <div>${this.enactingCountry}</div>
      </td>
      <td>
        <div class="dot ${this.tradeDirection}-dot">${this.typeOfMeasure}</div>
      </td>
      <td>
        <div class="box">
          <div>
            <span>${this.affectedProducts}</span>
            ${affectedHSCodes}
          </div>
        </div>
      </td>
      <td>
        <div>${this.measure}</div>
      </td>
      <td>
        <div class=${this.effectOnTrade === "restrictive" ? "import" : "export"}>${this.effectOnTrade}</div>
      </td>
      <td>
        <div>${this.affectedPartners}</div>
      </td>
      <td>
        <div class=${this.statusOfMeasure === "Active" ? "export" : "import"}>${this.statusOfMeasure}</div>
      </td>
      <td>
        <div>${this.startDate}</div>
      </td>
      <td>
        <div>${this.endDate}</div>
      </td>
    </tr>
    `
  }

  genHtmlMobile() {
    let affectedHSCodes = "";
    if (this.affectedHSCodes) {
      affectedHSCodes = `
      <div class="instruction">
        <div class="dropdown">
          <div class="content">
            <b>Official HS codes affected</b><div>${this.affectedHSCodes}</div>
          </div>
        </div>
      </div>
      `;
    }
    return `
    <div class="item ${this.tradeDirection}-dot">
      <div>
        <div><span class="label">Enacting Country: </span>${this.enactingCountry}</div>
      </div>
      <div>
        <div><span class="label">Type of measures: </span>${this.typeOfMeasure}</div>
      </div>
      <div>
        <div class="box">
          <div>
            <span class="label">Affected products: </span>
            <span>${capitalizeFirstLetter(this.affectedProducts)}</span>
            ${affectedHSCodes}
          </div>
        </div>
      </div>
      <div>
        <div><span class="label">Measures: </span>${this.measure}</div>
      </div>
      <div>
        <div class=${this.effectOnTrade === "restrictive" ? "import" : "export"}><span class="label">Effect on trade: </span><span class="text">${this.effectOnTrade}</span></div>
      </div>
      <div>
        <div><span class="label">Affected partners: </span>${this.affectedPartners}</div>
      </div>
      <div>
        <div class=${this.statusOfMeasure === "Active" ? "export" : "import"}><span class="label">Status of measures: </span>${this.statusOfMeasure}</div>
      </div>
      <div>
        <div><span class="label">Start date: </span>${this.startDate}</div>
      </div>
      <div>
        <div><span class="label">End date: </span>${this.endDate}</div>
      </div>
    </div>
    `
  }
}